document.addEventListener('DOMContentLoaded', () => {
  if (window.innerWidth < 990) return;

  const menuRoot = document.querySelector('.header__inline-menu');
  if (!menuRoot) return;

  const CLOSE_DELAY_MS = 220;
  const INTENT_RECHECK_MS = 80;
  const INTENT_GRACE_MS = 700;
  const menuDetails = menuRoot.querySelectorAll(':scope > .list-menu > li > header-menu > details');

  let closeTimer;
  let closeIntentDeadline = 0;
  let activeDetail = null;
  let pointer = { x: 0, y: 0 };
  let lastPointerInMenuRoot = null;

  const getActivePanel = () => {
    if (!activeDetail) return null;
    return activeDetail.querySelector('.mega-menu__content, .header__submenu');
  };

  const pointInTriangle = (point, a, b, c) => {
    const triAreaSign = (p1, p2, p3) => {
      return (p1.x - p3.x) * (p2.y - p3.y) - (p2.x - p3.x) * (p1.y - p3.y);
    };

    const d1 = triAreaSign(point, a, b);
    const d2 = triAreaSign(point, b, c);
    const d3 = triAreaSign(point, c, a);
    const hasNeg = d1 < 0 || d2 < 0 || d3 < 0;
    const hasPos = d1 > 0 || d2 > 0 || d3 > 0;

    return !(hasNeg && hasPos);
  };

  const isHeadingTowardPanel = () => {
    const panel = getActivePanel();
    if (!panel || !lastPointerInMenuRoot) return false;
    if (panel.matches(':hover')) return true;

    const rect = panel.getBoundingClientRect();
    if (pointer.x >= rect.left - 28 && pointer.x <= rect.right + 28 && pointer.y <= rect.bottom + 28) {
      return true;
    }

    const topLeft = { x: rect.left, y: rect.top };
    const topRight = { x: rect.right, y: rect.top };
    return pointInTriangle(pointer, lastPointerInMenuRoot, topLeft, topRight);
  };

  const closeAllMenus = () => {
    menuDetails.forEach((menuDetail) => {
      menuDetail.removeAttribute('open');
    });

    activeDetail = null;
  };

  const scheduleCloseAll = () => {
    clearTimeout(closeTimer);

    closeIntentDeadline = Date.now() + INTENT_GRACE_MS;

    const attemptClose = () => {
      if (menuRoot.matches(':hover')) return;

      if (Date.now() < closeIntentDeadline && isHeadingTowardPanel()) {
        closeTimer = setTimeout(attemptClose, INTENT_RECHECK_MS);
        return;
      }

      closeAllMenus();
    };

    closeTimer = setTimeout(attemptClose, CLOSE_DELAY_MS);
  };

  document.addEventListener('mousemove', (event) => {
    pointer = { x: event.clientX, y: event.clientY };

    if (menuRoot.matches(':hover')) {
      lastPointerInMenuRoot = { x: event.clientX, y: event.clientY };
    }
  });

  menuRoot.addEventListener('mouseenter', () => {
    clearTimeout(closeTimer);
  });

  menuRoot.addEventListener('mouseleave', scheduleCloseAll);

  menuDetails.forEach((detail) => {
    detail.addEventListener('mouseenter', () => {
      clearTimeout(closeTimer);

      menuDetails.forEach((menuDetail) => {
        if (menuDetail !== detail) menuDetail.removeAttribute('open');
      });

      activeDetail = detail;
      detail.setAttribute('open', '');
    });
  });
});